import React__default, { forwardRef } from 'react';
import { toAlignmentAttributes } from './Alignment/alignment.js';
import { toSpacingAttributes } from './Spacing/spacing.js';
import './Stack.scss';

const Stack = forwardRef(({ children, className, ariaLabel, id, margin, padding, itemsSpacing, itemsAlignX, itemsAlignY, tag, isScrollable, isPositionContainer, isFullHeight, }, ref) => {
    const Component = (tag || 'div');
    return (React__default.createElement(Component, { ref: ref, "data-rev-component": 'stack', className: className, id: id, "aria-label": ariaLabel, "data-rev-scrollable": isScrollable, "data-rev-position-container": isPositionContainer, "data-rev-full-height": isFullHeight, ...toSpacingAttributes('m', margin), ...toSpacingAttributes('p', padding), ...toSpacingAttributes('g', itemsSpacing), ...toAlignmentAttributes('x', itemsAlignX), ...toAlignmentAttributes('y', itemsAlignY) }, children));
});
Stack.displayName = 'Stack';

export { Stack };
//# sourceMappingURL=Stack.js.map
